export const parseIntDecimal = (value: string) => parseInt(value, 10);